// Web Push subscription helper
import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window;
}

export async function ensureServiceWorker() {
  if (!("serviceWorker" in navigator)) throw new Error("Service Worker desteklenmiyor");
  const reg = await navigator.serviceWorker.register("/sw.js");
  await navigator.serviceWorker.ready;
  return reg;
}

export async function getCurrentSubscription() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.ready;
    return await reg.pushManager.getSubscription();
  } catch {
    return null;
  }
}

export async function subscribeToPush() {
  if (!pushSupported()) throw new Error("Bu cihaz push bildirimini desteklemiyor");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Bildirim izni verilmedi");
  const reg = await ensureServiceWorker();
  const { data } = await api.get("/push/vapid-public-key");
  const applicationServerKey = urlBase64ToUint8Array(data.key);
  const subscription = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey });
  await api.post("/push/subscribe", { subscription: subscription.toJSON() });
  return subscription;
}

export async function unsubscribeFromPush() {
  const sub = await getCurrentSubscription();
  if (!sub) return true;
  try {
    await api.post("/push/unsubscribe", { subscription: sub.toJSON() });
  } catch {}
  return sub.unsubscribe();
}

export async function sendTestPush() {
  await api.post("/push/test");
}
